import { UploadId } from '../upload';
import { PathBuilder, ApiRoute, HttpMethod } from '../common';
import { LocationId } from '../location';
import { WorkflowStartResult } from '../external';
import { IPublishImageRequest } from './image';
import { IAuditDataWithChannel } from './audit';
import { addTermsAndConditionsToCaption } from './termsAndConditions';

export const MAX_TWEET_CHARACTER_LENGTH = 280;

export const MAX_MULTI_IMAGE_COUNT = 4;

export interface ITwitterPublishData {
    status?: string;
    scheduledTime?: Date;
}

export type IPublishPhotoToTwitterRequest = IPublishImageRequest<ITwitterPublishData>;

/**
 * @deprecated This is the old workflow input, required to reschedule with the original
 * data.
 */

export interface IPublishImageToTwitterWorkflowInputDeprecated {
    channelData: ITwitterPublishData;
    uploadId: UploadId | UploadId[];
    auditData: IAuditDataWithChannel;
    scheduledTime: Date;
}

export function isDeprecatedPublishImageToTwitterWorkflowInput(
    obj: IPublishImageToTwitterWorkflowInput | IPublishImageToTwitterWorkflowInputDeprecated,
): obj is IPublishImageToTwitterWorkflowInputDeprecated {
    return !!(obj as IPublishImageToTwitterWorkflowInputDeprecated).uploadId;
}

export interface IPublishImageToTwitterWorkflowInput {
    channelData: ITwitterPublishData;
    // We should always pass an array of uploadIds to the workflow input
    uploadIds: UploadId[];
    auditData: IAuditDataWithChannel;
    scheduledTime: Date;
}

interface TwitterPublishBaseParams {
    locationId: LocationId;
}

const TWITTER_PUBLISH_API_ROOT = <T extends TwitterPublishBaseParams>(path: PathBuilder<T>) =>
    path.literal('publish').literal('twitter').literal('location').param('locationId');

export const TwitterPublishApi = {
    canPostToTwitterForLocation: new ApiRoute<{ result: boolean }, TwitterPublishBaseParams, void, void>(
        HttpMethod.Get,
        path => TWITTER_PUBLISH_API_ROOT(path).literal('hasAccess'),
    ),
    publishPhoto: new ApiRoute<WorkflowStartResult, TwitterPublishBaseParams, IPublishPhotoToTwitterRequest, void>(
        HttpMethod.Post,
        path => TWITTER_PUBLISH_API_ROOT(path).literal('photo'),
    ),
};

/**
 * @deprecated - The twitterText package is causing the mobile app to break so it was removed
 * therefore this doesnt work correctly anymore
 * @param termsAndConditionsText -
 * @param termsAndConditionsUrl -
 * @param maxLength -
 * @returns -
 */
export function calculateTwitterMaxCharacterLimit(
    termsAndConditionsText: string | null,
    termsAndConditionsUrl: string | null,
    maxLength: number = MAX_TWEET_CHARACTER_LENGTH,
): number {
    if (termsAndConditionsText || termsAndConditionsUrl) {
        const termsAndConditions = addTermsAndConditionsToCaption('', termsAndConditionsText, termsAndConditionsUrl);
        const termsAndConditionsCharacterLength = termsAndConditions.length;
        return maxLength - termsAndConditionsCharacterLength;
    } else {
        return maxLength;
    }
}
